/**
 * Curated demo channel — plays on first visit and whenever the visitor's
 * queue is empty. See FR-027/FR-028: at least 5 items, at least one 4:3
 * source and one 16:9 source so the foundation visibly proves
 * Constitution Principle IV.
 *
 * Every identifier below was confirmed to have a working MP4 derivative
 * via the live metadata proxy during Phase 6 implementation.
 *
 *   Popeye_forPresident       — 1956 Popeye cartoon, 320×240 4:3 ambient color
 *   Nosferatu1922             — F.W. Murnau silent vampire film, 640×480 4:3
 *   thecabinetofdrcaligari    — 1920 German expressionism, 320×240 4:3
 *   BigBuckBunny_124          — 2008 Blender open movie, 640×360 16:9
 *   ElephantsDream            — 2006 Blender open movie, 640×360 16:9
 *
 * The retro-video-presentation-expert would add more vintage TV and
 * Prelinger items. For the foundation, these five carry the core values:
 * mixed aspect ratios, confirmed playability, a mix of silent-era
 * weirdness and modern ambient. We'll expand this list in a follow-on
 * spec once curation tooling exists.
 */

import type { DemoChannel } from "../../types.ts";

export const DEMO_CHANNEL: DemoChannel = {
  name: "Night Light Demo Channel",
  identifiers: [
    "Popeye_forPresident",
    "BigBuckBunny_124",
    "Nosferatu1922",
    "ElephantsDream",
    "thecabinetofdrcaligari",
  ],
};
